<template>
  <b-card no-body>
    <b-card-body>
      <provider-additional-fee-detail
        ref="providerAdditionalFeeDetail"
        type="edit"
        :submitting="submitting"
        :values="data"
        @submit="submit"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import ProviderAdditionalFeeDetail from '@/views/pages/providers/ProviderAdditionalFeeDetail.vue';

export default {
  components: {
    BCard,
    BCardBody,
    ProviderAdditionalFeeDetail
  },
  mixins: [helper],
  data() {
    return {
      submitting: false,
      data: {}
    };
  },

  created() {
    const providerId = this.$route.params.id;
    const feeId = this.$route.params.fee_id;
    this.getFeeData(providerId, feeId);
  },
  methods: {
    submit(data) {
      const request = {};

      const id = parseInt(this.$route.params.id);

      request.description = data.description;
      request.price = data.price;
      request.pricingType = data.pricingType;
      request.status = data.status;

      const feeId = this.$route.params.fee_id;

      this.submitting = true;
      useService
        .editProviderFee(id, feeId, request)
        .then(response => {
          this.showSuccessMessage(`${response.message}`);
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    getFeeData(providerId, feeId) {
      this.submitting = true;
      useService
        .getFee(providerId, feeId)
        .then(response => {
          this.data = response.data;

          const { description, price, pricingType, status } = response.data;

          this.data = {
            description,
            price,
            pricingType,
            status
          };
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
